require('./baseState.js');

PegasusTemplate.ValidatingState = PegasusTemplate.BaseState.extend({
  gotoIdle: Em.K,
  setup: function(manager){
    PegasusTemplate.set('status', 'saving');
  },
  error: function(){
    var errorMessages = PegasusTemplate.lookupController('header').get('errors.message'),
      targetMessage = Em.I18n.t('activerecord.errors.models.autoresponder.attributes.user.not_confirmed');

    if ( !!errorMessages ) {
      for (var i = 0; i < errorMessages.length; i++) {
        if ( errorMessages[i] === targetMessage ) {
          return;
        }
      }
    }

    PegasusTemplate.stateMachine.transitionTo('infoGathering');
  },
  confirming: PegasusTemplate.BaseState.extend({
    setup: function(){
      PegasusTemplate.get('externalProxy').set('mostRecentPath', 'confirm');
      PegasusTemplate.get('externalProxy').send('confirmRecord');
    }
  }),
  exiting: PegasusTemplate.BaseState.extend({
    setup: function(){
      PegasusTemplate.get('externalProxy').send('saveAndExitRecord');
    }
  }),
  previewing: PegasusTemplate.BaseState.extend({
    setup: function(){
      PegasusTemplate.get('externalProxy').send('previewEditorContent');
    }
  }),
  testing: PegasusTemplate.BaseState.extend({
    setup: function(){
      PegasusTemplate.get('externalProxy').set('mostRecentPath', 'testEmail');
      PegasusTemplate.get('externalProxy').send('openSendTestEmailModal');
    },
    success: function(){
      PegasusTemplate.stateMachine.transitionTo('idling');
    }
  })
});
